import React from "react";
import {
  Table,
} from "reactstrap";
import DeleteButton from "../../../../components/Buttons/DeleteButton";
import StandModel from "../../../../utils/models/StandModel";
import LoadingSkelentonTable from "../../../../components/loadingSkeletonTable";

export default function StandsList({
  standsList = [],
  openModalInactiveGroup,
  loading = false,
}) {
  return (
    <div style={{ paddingBottom: '10px' }}>
      <div className="table-responsive">
        <Table className="table mb-0">
          <thead className="table-light">
            <tr>
              <th>Grupo</th>
              <th>Ações</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <LoadingSkelentonTable lines={10} cols={2} />
            ) : (
              standsList.map(s => renderRow(s))
            )}
          </tbody>
        </Table>
      </div>
    </div>
  )

  function renderRow(stand = StandModel()) {
    return (
      <tr key={stand.id}>
        <th>{stand.organizationName}</th>
        <td>
          <>
            <DeleteButton
              onClick={async () => openModalInactiveGroup(stand)}
              color="red"
              fontSize={17}
            />
          </>
        </td>
      </tr>
    )
  }
}
